import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MetaData from "../meta-data";
import MainLayout from "../../components/layout/MainLayout";
import ParcelOrder from "../../components/my-orders/order-details/parcel-order/ParcelOrder";
import OtherOrder from "../../components/my-orders/order-details/other-order";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import OrderDetails from "../../components/my-orders/order-details";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const index = ({ configData }) => {
  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Order details` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData}>
        <OrderDetails configData={configData} />
      </MainLayout>
    </>
  );
};

export default index;
